import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=9038ceee&scoped=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"
import style0 from "./Card.vue?vue&type=style&index=0&id=9038ceee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9038ceee",
  null
  
)

export default component.exports